module.exports = __webpack_public_path__ + "img/defense-satellite.b7d55963.svg";